import { PortalContextService } from '@/core/services/portal-context.service';
import { SectionService } from '@/core/services/section.service';
import { ActivatedRoute, NavigationCancel, Router } from '@angular/router';
import { Component, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { FormGroup } from '@angular/forms';
import { MoveDirection } from '../anfrage-navigation-form/anfrage-navigation-form.component';

export interface INavigationForm {
  get canGoNext(): boolean;
  get canGoBack(): boolean;
  onSaveClick(): void;
  onSaveAndNextClick(): void;
  onNextClick(): void;
  onBackClick(): void;
  goBack(): void;
  next(): void;
}

@Component({
  selector: 'base-navigation-form',
  template: ''
})
export abstract class BaseNavigationFormComponent implements INavigationForm, OnDestroy {

  public abstract get formGroup(): FormGroup;
  protected canceledRoute: string;
  protected subscriptions: Subscription[] = [];

  constructor(protected sectionService: SectionService, protected router: Router, protected route: ActivatedRoute, protected portalContextService: PortalContextService) {

    let navigationCancel: Observable<NavigationCancel> = this.router.events.pipe(filter(event => event instanceof NavigationCancel), map(event => <NavigationCancel>event));
    this.subscriptions.push(navigationCancel.subscribe((event) => {
      this.canceledRoute = event.url;
    }));
  }

  public get canGoNext(): boolean {
    return this.sectionService.canGoNext(this.router);
  }

  public get canGoBack(): boolean {
    return this.sectionService.canGoBack(this.router);
  }

  public get canSave(): boolean {
    return !this.formGroup.disabled;
  }

  public onSaveClick(): void {
    this.save(!this.formGroup.disabled, MoveDirection.STAY);
  }

  public onSaveAndNextClick(): void {
    this.save(!this.formGroup.disabled, MoveDirection.NEXT);
  }

  public onNextClick(): void {
    this.next();
  }

  public onBackClick(): void {
    this.save(!this.formGroup.disabled, MoveDirection.BACK);
  }

  public goBack(): void {
    this.sectionService.previous(this.router, this.route);
  }

  public next(): void {
    this.sectionService.next(this.router, this.route);
  }

  public move(moveDirection: MoveDirection): void {
    if (moveDirection == MoveDirection.NEXT) {
      this.next();
    }
    else if (moveDirection == MoveDirection.BACK) {
      this.goBack();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  protected abstract save(shouldSave: boolean, moveDirection: MoveDirection): void;
}
